import React from "react";
import { BlockMath, InlineMath } from "react-katex";
import TheoryExamplesRunner from "../../components/TheoryExamplesRunner";

export default function ProbabilityBasicsPreparationTheory() {
  const intro = (
    <div className="space-y-3">
      <p>
        W rachunku prawdopodobieństwa najpierw ustalamy wszystkie możliwe wyniki
        doświadczenia, czyli <strong>przestrzeń zdarzeń elementarnych</strong>{" "}
        <InlineMath math="\Omega" />. Następnie wybieramy wyniki sprzyjające
        zdarzeniu <InlineMath math="A" />.
      </p>
      <p>
        Jeżeli wszystkie wyniki są jednakowo prawdopodobne, korzystamy ze wzoru:
      </p>
      <BlockMath math={String.raw`P(A)=\frac{|A|}{|\Omega|}`} />
      <p>
        Symbol <InlineMath math={String.raw`|\Omega|`} /> oznacza liczbę wszystkich
        możliwych wyników, a <InlineMath math={String.raw`|A|`} /> — liczbę wyników
        sprzyjających. Otrzymany ułamek warto skrócić.
      </p>
      <p>
        Przy dwóch rzutach kostką wynik zapisujemy jako uporządkowaną parę
        <InlineMath math="(i,j)" />. Wyniki <InlineMath math="(2,5)" /> i
        <InlineMath math="(5,2)" /> są różne, dlatego:
      </p>
      <BlockMath math={String.raw`|\Omega|=6\cdot6=36`} />
      <p>
        <strong>Zdarzenie przeciwne</strong> <InlineMath math="A'" /> zachodzi wtedy,
        gdy nie zachodzi zdarzenie <InlineMath math="A" />:
      </p>
      <BlockMath math={String.raw`P(A')=1-P(A)`} />
      <p>
        Najbezpieczniejszy schemat rozwiązania: zapisz
        <InlineMath math="\Omega" />, opisz zdarzenie, policz wyniki sprzyjające,
        a dopiero potem podstaw liczby do odpowiedniego wzoru.
      </p>
    </div>
  );

  const examples = [
    {
      label: "Przykład 1",
      summary: "Jedna kula z urny",
      description: "W urnie są 3 kule białe i 5 czarnych. Losujemy jedną kulę.",
      content: (
        <div>
          <p>Obliczamy prawdopodobieństwo wylosowania białej kuli.</p>
          <BlockMath math={String.raw`|\Omega|=3+5=8,\qquad |A|=3`} />
          <BlockMath math={String.raw`P(A)=\frac{|A|}{|\Omega|}=\frac38`} />
        </div>
      ),
    },
    {
      label: "Przykład 2",
      summary: "Dwie kostki — suma oczek",
      description: "Rzucamy dwiema kostkami. Obliczamy prawdopodobieństwo sumy równej 9.",
      content: (
        <div>
          <BlockMath math={String.raw`|\Omega|=36`} />
          <p>Sprzyjające pary to <InlineMath math="(3,6),(4,5),(5,4),(6,3)" />.</p>
          <BlockMath math={String.raw`P(A)=\frac4{36}=\frac19`} />
        </div>
      ),
    },
    {
      label: "Przykład 3",
      summary: "Zdarzenie przeciwne",
      description: "Prawdopodobieństwo zdania sprawdzianu wynosi 3/4.",
      content: (
        <div>
          <p>Zdarzeniem przeciwnym jest niezdanie sprawdzianu.</p>
          <BlockMath math={String.raw`P(A')=1-P(A)=1-\frac34=\frac14`} />
        </div>
      ),
    },
  ];

  return <TheoryExamplesRunner intro={intro} examples={examples} />;
}
